import { convertFromRaw } from 'draft-js';
import { SelfDirectedAction } from './SelfDirectedActivityDialog';

interface DetailSession {
  sessionId: string;
  name: string;
  description?: string | null;
  individualReports?: string | null;
  completedByCurrentVolunteer?: boolean | null;
  reportType?: { name?: string | null } | null;
  remoteLocation?: { details?: string | null } | null;
}

const toPlainText = (raw?: string | null): string | null => {
  if (!raw) return null;
  try {
    const text = convertFromRaw(JSON.parse(raw)).getPlainText().trim();
    return text.length > 0 ? text : null;
  } catch (_unusedError) {
    return raw;
  }
};

export const mapSessionsToActions = (sessions: DetailSession[]): SelfDirectedAction[] =>
  sessions.map((session) => ({
    sessionId: session.sessionId,
    name: session.name,
    description: toPlainText(session.description),
    detail: session.reportType?.name ?? null,
    externalLink: session.remoteLocation?.details ?? null,
    mandatory: session.individualReports === 'mandatory',
    completed: Boolean(session.completedByCurrentVolunteer),
  }));
